(() => { if(window.slpfPurchaseInstalled)return;window.slpfPurchaseInstalled=true;
function init(el){ const sectionId=el.dataset.sectionId;let config;try{config=JSON.parse(el.textContent)}catch(e){return;}

  'use strict';

  const root = document.getElementById("slp-" + sectionId + "");
  if (!root || root.dataset.slpfBound) return;
  root.dataset.slpfBound = 'true';
  const controller = new AbortController();
  root.slpfController = controller;

  const purchaseMode = root.dataset.purchaseMode;
  const afterAdd = root.dataset.afterAdd;
  const productUrl = config.v0;
  const cartRoot = (
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
  ) ? Shopify.routes.root : '/';

  const cartAddUrl = cartRoot + 'cart/add.js';
  const cartUrl = config.v1;
  const modal = document.getElementById("slp-modal-" + sectionId + "");
  const variantsBox = modal ? modal.querySelector('[data-slp-variants]') : null;
  const modalBuy = modal ? modal.querySelector('[data-slp-modal-buy]') : null;
  const toast = document.getElementById("slp-toast-" + sectionId + "");
  const toastText = toast ? toast.querySelector('[data-slp-toast-text]') : null;
  const productJsonEl = document.getElementById("slp-product-json-" + sectionId + "");

  let product = null;
  let selectedVariant = null;

  if (productJsonEl) {
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {}
  }

  function track(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign({event:eventName}, payload || {})
      );
    } catch (e) {}
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style:'currency',
          currency:config.v2
        }
      ).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100)
        .toFixed(2)
        .replace('.', ',') + ' €';
    }
  }

  function availableVariants() {
    return product && product.variants
      ? product.variants.filter(v => v.available)
      : [];
  }

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function showToast(message) {
    if (!toast) return;
    if (toastText) toastText.textContent = message;
    toast.classList.add('is-show');
    window.setTimeout(() => {
      toast.classList.remove('is-show');
    }, 4500);
  }

  async function addToCart(variantId) {
    const response = await fetch(cartAddUrl, {
      method:'POST',
      credentials:'same-origin',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        items:[{id:Number(variantId),quantity:1}]
      })
    });

    if (!response.ok) throw new Error('add_failed');
    return response.json();
  }

  function afterSuccessfulAdd(message) {
    if (afterAdd === 'checkout') {
      window.location.href = cartRoot + 'checkout';
      return;
    }
    if (afterAdd === 'cart') {
      window.location.href = cartUrl;
      return;
    }

    showToast(message || config.v3);
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {bubbles:true})
    );
  }

  function renderVariants() {
    if (!variantsBox || !product || !product.variants) return;

    variantsBox.innerHTML = '';
    selectedVariant = null;

    product.variants.forEach(variant => {
      const label = document.createElement('label');
      label.className = 'slp-variant' + (
        variant.available ? '' : ' is-disabled'
      );

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = "slp-variant-" + sectionId + "";
      radio.value = variant.id;
      radio.disabled = !variant.available;

      const title = document.createElement('span');
      title.textContent = variant.title === 'Default Title'
        ? config.v4
        : variant.title;

      const price = document.createElement('span');
      price.className = 'slp-variant-price';
      price.textContent = money(variant.price);

      label.appendChild(radio);
      label.appendChild(title);
      label.appendChild(price);
      variantsBox.appendChild(label);

      if (variant.available && !selectedVariant) {
        selectedVariant = variant;
        radio.checked = true;
      }

      radio.addEventListener('change', function () {
        if (this.checked) selectedVariant = variant;
      });
    });
  }

  async function handleBuyClick(event) {
    const anchor = event.currentTarget;

    track('slp_primary_cta_click', {
      product:product ? product.handle : null,
      label:anchor.textContent.trim()
    });

    if (purchaseMode !== 'direct_cart' || !product) return;

    event.preventDefault();
    const variants = availableVariants();

    if (!variants.length) {
      window.location.href = productUrl;
      return;
    }

    if (variants.length === 1) {
      anchor.setAttribute('aria-busy', 'true');

      try {
        await addToCart(variants[0].id);
        track('slp_add_to_cart', {
          product:product.handle,
          variant_id:variants[0].id
        });
        afterSuccessfulAdd(config.v3);
      } catch (e) {
        window.location.href = productUrl;
      } finally {
        anchor.removeAttribute('aria-busy');
      }
      return;
    }

    renderVariants();
    openModal();
  }

  root.addEventListener('click', event => { const anchor = event.target.closest('[data-slp-buy]'); if(anchor && root.contains(anchor)) handleBuyClick({currentTarget:anchor, preventDefault:()=>event.preventDefault()}); });

  root.addEventListener('click', async function(event) {
      const button = event.target.closest('[data-slp-upsell-add]');
      if(!button || !root.contains(button)) return;
      event.preventDefault();
      await (async function() {
      const id = this.dataset.variantId;
      const old = this.textContent;

      this.disabled = true;
      this.textContent = config.v5;

      try {
        await addToCart(id);
        track('slp_upsell_add', {variant_id:id});
        afterSuccessfulAdd(config.v6);
      } catch (e) {
        window.location.href = config.v7;
      } finally {
        this.disabled = false;
        this.textContent = old;
      }
      }).call(button);
  });

  if (modalBuy) {
    modalBuy.addEventListener('click', async function () {
      if (!selectedVariant) return;

      const old = this.textContent;
      this.disabled = true;
      this.textContent = config.v8;

      try {
        await addToCart(selectedVariant.id);
        track('slp_add_to_cart', {
          product:product.handle,
          variant_id:selectedVariant.id
        });
        closeModal();
        afterSuccessfulAdd(config.v3);
      } catch (e) {
        closeModal();
        window.location.href = productUrl;
      } finally {
        this.disabled = false;
        this.textContent = old;
      }
    });
  }

  if (modal) {
    modal.querySelectorAll('[data-slp-modal-close]').forEach(button => {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        modal.classList.contains('is-open')
      ) {
        closeModal();
      }
    }, {signal:controller.signal});
  }

}
function boot(){document.querySelectorAll('[data-slpf-config]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.slp').forEach(r=>r.slpfController?.abort()));
})();
